import { useQuery } from '@sequencehq/api'
import {
  Dashboardv99990101Api,
  dashboardv99990101Client
} from '@sequencehq/api/dashboard/v99990101'

type TriggerType = Dashboardv99990101Api.Automations.TriggerType

export const getIsAutomationActive = async (props: {
  triggerType: TriggerType
}) => {
  const activeAutomation =
    await dashboardv99990101Client.getAllAutomationVersions({
      triggerType: props.triggerType,
      active: true
    })

  return !!activeAutomation.data?.items.length
}

export const useIsAutomationActive = (props: { triggerType: TriggerType }) => {
  const activeAutomation = useQuery(
    dashboardv99990101Client.getAllAutomationVersions,
    {
      triggerType: props.triggerType,
      active: true
    }
  )

  return {
    isPending: activeAutomation.isPending,
    isActive: !!activeAutomation.data?.items.length
  }
}
